import axios from './base'

const url = {
  add: '/api/notes',
  get: (noteId) => `/api/notes/${noteId}`,
  rename: (noteId) => `/api/notes/${noteId}/name`,
  changeContent: (noteId) => `/api/notes/${noteId}/content`,
  changeTags: (noteId) => `/api/notes/${noteId}/tags`,
  remove: (noteId) => `/api/notes/${noteId}`
}

export default {
  async add ({ name }) {
    return await axios.post(url.add, { name })
  },
  async get (id) {
    return await axios.get(url.get(id))
  },
  async rename ({ id, name, lastVersion }) {
    return await axios.put(url.rename(id), {
      name,
      lastVersion
    })
  },
  async changeContent ({ id, content, lastVersion }) {
    return await axios.put(url.changeContent(id), {
      content,
      lastVersion
    })
  },
  async changeTags ({ id, tagNames, lastVersion }) {
    return await axios.put(url.changeTags(id), {
      tagNames,
      lastVersion
    })
  }
}
